import { articleListImageConfigurations }
  from './imageConfigurations';
import getNewsboardFieldVariables
  from './queries/getNewsboardFieldVariables';
import { Newsboard } from './graphql/api/graphql';

const getPartnerVariables = (
  prefix: string,
  hasLocalNews: boolean,
  newsboard: Newsboard,
) => ({
  ...getNewsboardFieldVariables(prefix, hasLocalNews),
  pageviews: false,
  partnerContent: true,
  first: 4,
  newsboards: [newsboard],
  imageConfigurations: articleListImageConfigurations,
});

export default getPartnerVariables;
